<div class="meteo_details">

  <div class="compass" id="compass">
    <div class="direction" id="nne">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="ne">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="ene">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="e">
      <div class="direction_value east">E</div>
    </div>
    <div class="direction" id="ese">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="se">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="sse">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="s">
      <div class="direction_value south">S</div>
    </div>
    <div class="direction" id="sso">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="so">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="oso">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="o">
      <div class="direction_value">O</div>
    </div>
    <div class="direction" id="ono">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="no">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="nno">
      <div class="direction_value"></div>
    </div>
    <div class="direction" id="n">
      <div class="direction_value">N</div>
    </div>
  </div>

  <div class="infos">
    <div class="temp">{{infoCity.weather}}°C</div>
    <div class="temp_max_min">{{infoCity.airTemperature}}°C/{{infoCity.airQuality}}°C</div>
    <div class="swel"> <img src="assets/img/icon-blue/vague.svg" alt=""> {{infoCity.swellPeriodicity}}m
      <img src="assets/img/icon-blue/houle.svg" alt="">{{infoCity.swellHeight}}m</div>
    <div class="wind_pression">
      <span class="wind">{{infoCity.windChill}} kts {{infoCity.windDirectionString}}</span>
      <span class="pression">{{infoCity.mslPressure}} hpa</span>
    </div>
    <div class="wind_gust">
      <p>Rafales</p>
      <span>{{infoCity.windGust || 0}}kts</span>
    </div>
  </div>
</div>
